import { PassPage } from './pages/PassPage';
import { SupportStatusPage } from './pages/SupportStatusPage';
import { PollPage } from './pages/PollPage';
import { ShareTargetPage } from './components/TicketPaste';
import { InboxPage } from './pages/InboxPage';
import { SeatMapPage } from './pages/SeatMapPage';
import { MyPostsPage } from './pages/MyPostsPage';
import { RowPage } from './pages/RowPage';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ComparePage } from './pages/ComparePage';
import { CoveragePage } from './pages/CoveragePage';
import { FitPage } from './pages/FitPage';
import { LandingPage } from './pages/LandingPage';
import { SeatDuelPage } from './pages/SeatDuelPage';
import { LegalPage } from './pages/LegalPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PassportPage } from './pages/PassportPage';
import { ReviewPage } from './pages/ReviewPage';
import { SeatPage } from './pages/SeatPage';
import { SettingsPage } from './pages/SettingsPage';
import { StartPage } from './pages/StartPage';
import { VenuePage } from './pages/VenuePage';
import { ViewingPlanPage } from './pages/ViewingPlanPage';

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<SeatDuelPage />} />
        <Route path="explore" element={<LandingPage />} />
        <Route path="start" element={<StartPage />} />
        <Route path="venue/:venueSlug/:spaceId/:floorId/:sectionSlug/:rowLabel" element={<RowPage />} />
        <Route path="venue/:venueSlug" element={<VenuePage />} />
        <Route path="venue/:venueSlug/:sectionCode" element={<VenuePage />} />
        <Route path="seat/:candidateId" element={<SeatPage />} />
        <Route path="compare" element={<ComparePage />} />
        <Route path="decision/:id" element={<ComparePage />} />
        <Route path="passport" element={<PassportPage />} />
        <Route path="visit-plan" element={<ViewingPlanPage />} />
        <Route path="p/:id" element={<PollPage />} />
        <Route path="pass" element={<PassPage />} />
        <Route path="support/status" element={<SupportStatusPage />} />
        <Route path="share" element={<ShareTargetPage />} />
        <Route path="inbox" element={<InboxPage />} />
        <Route path="me/seat-map" element={<SeatMapPage />} />
        <Route path="me/posts" element={<MyPostsPage />} />
        <Route path="me/fit" element={<FitPage />} />
        <Route path="review/new" element={<ReviewPage />} />
        <Route path="review/:id" element={<ReviewPage />} />
        <Route path="report/:reviewId" element={<LegalPage kind="report" />} />
        <Route path="coverage" element={<CoveragePage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="privacy" element={<LegalPage kind="privacy" />} />
        <Route path="terms" element={<LegalPage kind="terms" />} />
        <Route path="support" element={<LegalPage kind="support" />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
